function groupFilter_OnChange(elementId, val) {
    var value, holderDiv, display;
    value = parseInt(val, 10);
    holderDiv = document.getElementById(elementId);
    display = (value == 1 || value == 2);
    holderDiv.style.display = (display) ? '' : 'none';
    if (typeof showSelectionInCalendar === 'function') {
        showSelectionInCalendar();
    }
}